/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightSupportRecovery
 */
export interface FlightSupportRecovery {
    /**
     * Current booking-recovery status; this field is always present when the recovery object is present.
     * @type {string}
     * @memberof FlightSupportRecovery
     */
    status: FlightSupportRecoveryStatusEnum;
    /**
     * Bounded explanation for the recovery status; this field is never null.
     * @type {string}
     * @memberof FlightSupportRecovery
     */
    reason: FlightSupportRecoveryReasonEnum;
    /**
     * Number of pending booking-recovery records represented by this booking projection (currently zero or one); excludes ordinary delivery and provider-event backlog.
     * @type {number}
     * @memberof FlightSupportRecovery
     */
    pendingCount: number;
    /**
     * Number of exhausted booking-recovery records represented by this booking projection (currently zero or one).
     * @type {number}
     * @memberof FlightSupportRecovery
     */
    exhaustedCount: number;
    /**
     * Persisted booking-recovery attempt counter. The count alone does not make recovery pending; pending requires an explicit availability or lease marker.
     * @type {number}
     * @memberof FlightSupportRecovery
     */
    attempts: number;
    /**
     * Persisted next recovery availability time, or null when no recovery is scheduled (including while an active lease owns the work).
     * @type {Date}
     * @memberof FlightSupportRecovery
     */
    availableAt: Date | null;
    /**
     * Persisted recovery exhaustion time, or null when recovery has not been exhausted.
     * @type {Date}
     * @memberof FlightSupportRecovery
     */
    exhaustedAt: Date | null;
}


/**
 * @export
 */
export const FlightSupportRecoveryStatusEnum = {
    NotNeeded: 'not_needed',
    Pending: 'pending',
    Exhausted: 'exhausted',
    Unknown: 'unknown'
} as const;
export type FlightSupportRecoveryStatusEnum = typeof FlightSupportRecoveryStatusEnum[keyof typeof FlightSupportRecoveryStatusEnum];

/**
 * @export
 */
export const FlightSupportRecoveryReasonEnum = {
    NoPersistedRecoveryWork: 'no_persisted_recovery_work',
    PersistedRecoveryPending: 'persisted_recovery_pending',
    PersistedRecoveryExhausted: 'persisted_recovery_exhausted',
    CompatibilityUnknown: 'compatibility_unknown'
} as const;
export type FlightSupportRecoveryReasonEnum = typeof FlightSupportRecoveryReasonEnum[keyof typeof FlightSupportRecoveryReasonEnum];


/**
 * Check if a given object implements the FlightSupportRecovery interface.
 */
export function instanceOfFlightSupportRecovery(value: object): value is FlightSupportRecovery {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('pendingCount' in value) || value['pendingCount'] === undefined) return false;
    if (!('exhaustedCount' in value) || value['exhaustedCount'] === undefined) return false;
    if (!('attempts' in value) || value['attempts'] === undefined) return false;
    if (!('availableAt' in value) || value['availableAt'] === undefined) return false;
    if (!('exhaustedAt' in value) || value['exhaustedAt'] === undefined) return false;
    return true;
}

export function FlightSupportRecoveryFromJSON(json: any): FlightSupportRecovery {
    return FlightSupportRecoveryFromJSONTyped(json, false);
}

export function FlightSupportRecoveryFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightSupportRecovery {
    if (json == null) {
        return json;
    }
    return {

        'status': json['status'],
        'reason': json['reason'],
        'pendingCount': json['pending_count'],
        'exhaustedCount': json['exhausted_count'],
        'attempts': json['attempts'],
        'availableAt': (json['available_at'] == null ? null : new Date(json['available_at'])),
        'exhaustedAt': (json['exhausted_at'] == null ? null : new Date(json['exhausted_at'])),
    };
}

export function FlightSupportRecoveryToJSON(json: any): FlightSupportRecovery {
    return FlightSupportRecoveryToJSONTyped(json, false);
}

export function FlightSupportRecoveryToJSONTyped(value?: FlightSupportRecovery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'status': value['status'],
        'reason': value['reason'],
        'pending_count': value['pendingCount'],
        'exhausted_count': value['exhaustedCount'],
        'attempts': value['attempts'],
        'available_at': value['availableAt'] == null ? value['availableAt'] : value['availableAt'].toISOString(),
        'exhausted_at': value['exhaustedAt'] == null ? value['exhaustedAt'] : value['exhaustedAt'].toISOString(),
    };
}

